import React, { useEffect, useRef } from "react";
import { Asset } from "../DefaultLayout/DefaultLayout";
import styles from "./AssetParser.module.scss";

interface IAssetParserProps {
  assetOptions: Asset;
  className: any;
  isBackgroundVideo?: boolean;
  active?: boolean;
}

export const AssetParser: React.FC<IAssetParserProps> = (props) => {
  const {
    assetOptions,
    className,
    isBackgroundVideo = false,
    active = false,
  } = props;

  const bgVideo = useRef(null);
  const video = useRef(null);

  useEffect(() => {
    if (assetOptions.asset.format === "mp4") {
      if (active && isBackgroundVideo && bgVideo) {
        bgVideo.current.play();
        return;
      }
      if (active && video) {
        video.current.play();
      }
    }
  }, [active, assetOptions.asset.format, isBackgroundVideo, bgVideo, video]);

  if (assetOptions.asset.format === "mp4") {
    if (isBackgroundVideo) {
      return (
        <div
          className={className}
          style={{
            overflow: "hidden",
            position: "relative",
            height: "100%",
          }}
        >
          <video
            ref={bgVideo}
            width={assetOptions.asset.width}
            height={assetOptions.asset.height}
            className={`${styles.bgvideo}`}
            autoPlay={active ? true : false}
            loop={assetOptions.videoLoop ? true : false}
            muted={assetOptions.videoMuted ? true : false}
            playsInline
          >
            <source src={assetOptions.asset.url} type="video/mp4" />
            Your browser does not support mp4 videos.
          </video>
        </div>
      );
    } else {
      return (
        <video
          ref={video}
          width={assetOptions.asset.width}
          height={assetOptions.asset.height}
          className={`${styles.video} ${className}`}
          autoPlay={active ? true : false}
          loop={assetOptions.videoLoop ? true : false}
          muted={assetOptions.videoMuted ? true : false}
          playsInline
        >
          <source src={assetOptions.asset.url} type="video/mp4" />
          Your browser does not support mp4 videos.
        </video>
      );
    }
  } else {
    return (
      <picture>
        <source
          srcSet={assetOptions.asset.responsiveImage.webpSrcSet}
          type="image/webp"
        />
        <source srcSet={assetOptions.asset.responsiveImage.srcSet} />
        <img
          src={assetOptions.asset.url}
          alt="decorative"
          loading="eager"
          className={className}
        />
      </picture>
    );
  }
};
